export enum ConfigRuleTypeDto {
    VISIBLE = 'visible',
}
